// extracted by mini-css-extract-plugin
export default {"button":"style_button__0ZUXT","gradient":"style_gradient__X3BZS","reverse":"style_reverse__G7qqx","icon":"style_icon__K+GmW","circle":"style_circle__eJCO0"};